(() => {
  if (window.catalogAvailabilityInitialized) return;
  window.catalogAvailabilityInitialized = true;

  const queue = [];
  let active = 0;
  const maxConcurrent = 3;

  async function collectionHasAvailableProduct(path) {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin || !/\/collections\/[^/]+\/?$/.test(url.pathname)) {
      throw new Error('Invalid collection URL');
    }
    url.pathname = `${url.pathname.replace(/\/$/, '')}/products.json`;
    url.search = '';

    for (let page = 1; ; page += 1) {
      url.searchParams.set('limit', '250');
      url.searchParams.set('page', String(page));
      const response = await fetch(url, { cache: 'no-store', credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Collection availability request failed: ${response.status}`);
      const payload = await response.json();
      if (!Array.isArray(payload.products)) throw new Error('Invalid collection products response');
      if (payload.products.some((product) => product.variants?.some((variant) => variant.available))) {
        return true;
      }
      if (payload.products.length < 250) return false;
    }
  }

  function updateSection(card) {
    const section = card.closest('[data-catalog-availability-section]');
    if (!section) return;
    const group = card.closest('[data-catalog-availability-group]');
    if (group && !group.querySelector('[data-catalog-availability-check]:not([data-catalog-availability-done])')) {
      group.hidden = !group.querySelector('[data-catalog-availability-card]:not([hidden])');
    }
    const unresolved = section.querySelector('[data-catalog-availability-check]:not([data-catalog-availability-done])');
    if (!unresolved) {
      section.hidden = !section.querySelector('[data-catalog-availability-card]:not([hidden])');
    }
  }

  async function checkCard(card) {
    try {
      if (await collectionHasAvailableProduct(card.dataset.catalogAvailabilityCheck)) {
        card.hidden = false;
      }
    } catch (error) {
      // Keep navigation accessible if Shopify's public endpoint is temporarily unavailable.
      card.hidden = false;
      console.warn('Collection availability could not be checked:', error);
    } finally {
      card.dataset.catalogAvailabilityDone = 'true';
      updateSection(card);
    }
  }

  function drain() {
    while (active < maxConcurrent && queue.length) {
      const card = queue.shift();
      active += 1;
      checkCard(card).finally(() => {
        active -= 1;
        drain();
      });
    }
  }

  function scan(root) {
    root.querySelectorAll('[data-catalog-availability-check]:not([data-catalog-availability-queued])').forEach((card) => {
      card.dataset.catalogAvailabilityQueued = 'true';
      queue.push(card);
    });
    drain();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  } else {
    scan(document);
  }
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
